import React, { useEffect } from "react";
import { Col, DatePicker, Flex, InputNumber, Row } from "antd";
import { useState } from "react";
import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import styles from "./ElitePremium.module.scss";
import {
  getAdminSubscriptionsAction,
  updateSubscriptionPlanByIdAction,
} from "../../../../../../redux/services/service-provider-subscriptions/serviceProviderSubscriptionsServices";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { getSubscriptionPlansAction, updateSubscriptionPlanAction } from "../../../../../../redux/services/subscription-plan/subscriptionPlanServices";
import Actions from "../../../../../../redux/actions";

const ElitePremium = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  const elite_premium_key = "ELITE-PREMIUM";

  /* form dependencies */
  const [form] = Form.useForm();
  const {subscriptionPlans} = useSelector((state)=>state.subscriptionPlans)
  const initialValues = {
    price: "",
    freeLogins:"",
    duration: null
  };
  const [periodOptions, setPeriodOptions] = useState([
    { value: 1, label: "01 month" },
    { value: 4, label: "04 months" },
    { value: 6, label: "06 months" },
    { value: 12, label: "12 months" }
  ])
  /* form dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    form.setFieldValue("freeLogins", 5);
    form.setFieldValue("freeLogins", subscriptionPlans?.data?.find((element)=>element.code === elite_premium_key).number_of_logins)
    const dataToBeSent = {}
    dispatch(getSubscriptionPlansAction(dataToBeSent, setLoading))
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, []);

  /* reset default form fields */
  const resetDefaultFields = () => {
    form.setFieldsValue({
      price: initialValues.price,
      duration: initialValues.duration
    });
  }
  /* reset default form fields */

  const handleViewList = () => {
    dispatch(Actions.createAction(Actions.SELECTED_SUBSCRIPTION_PLAN_LOG_ID, {selectedCurrentSubscriptionPlanId:elite_premium_key, navigateBack:baseRouteMakerForSuperAdmin(routes.ELITE_PREMIUM)}))
    navigate(baseRouteMakerForSuperAdmin(routes.SUBSCRIPTION_PLAN_LIST))
  }

  /* Form submit handler */
  const onSubmit = (values) => {

    const currentElement = subscriptionPlans?.data?.find((element)=>element.code === elite_premium_key)
    const tempPricingArr = JSON.parse(JSON.stringify(currentElement.pricing))
    const pricingObj = tempPricingArr?.find((elem)=>elem?.duration === values?.duration)
    pricingObj["price"] = Number(values?.price);

    const dataToBeSent = {
      code:elite_premium_key,
      name:"Elite Premium",
      plan_for:"organization",
      number_of_logins:Number(values?.freeLogins) || 0,
      pricing:tempPricingArr,
      _id:currentElement?._id
    }
    dispatch(updateSubscriptionPlanAction(dataToBeSent, setLoading))
    resetDefaultFields()
  };
  /* Form submit handler */

  return (
    <div className={styles.elitePremiumContainer}>
      <Flex vertical gap="2rem">
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Row gutter={[24, 24]} justify="space-between">
          <Col span={8}>
            <Form.Item
              name="duration"
              label={<RequiredLabel text={t("Modules.Ads.period")} required={true} />}
              rules={[{required: true, message: t("Modules.Ads.pleaseSelectPeriod")}]}
            >
              <Select
                loading={selectListLoader}
                options={periodOptions}
                placeholder={t("Modules.Ads.selectPeriod")}
              />
            </Form.Item>
          </Col>
          <Col span={2}>
          <Button
              type="primary"
              loading={loading}
              disabled={loading}
              style={{ marginTop: "10px" }}
              onClick={(e) => handleViewList(e)}
            >
              {t("CommonUtils.logs")}
            </Button>
          </Col>
          </Row>

          <Row gutter={[24, 24]}>
            <Col span={8}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.ElitePremium.freeLogins")}
                  required={true}
                />
              }
              name="freeLogins"
              rules={[
                {
                  required: true,
                  message: t("Modules.ElitePremium.pleaseEnterFreeLogins"),
                },
                {
                  validator:(_, value) => {
                    if(value && value < 1) return Promise.reject(`${t("Modules.ElitePremium.freeLogins")} ${t("CommonUtils.shouldBeGreaterThan0")}`);
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <Input
                type="number"
                placeholder={t("Modules.ElitePremium.enterFreeLogins")}
                onKeyDown={(e)=>allowCharactersOnlyForDecimalNumbers(e)}
              />
            </Form.Item>
          </Col>

            <Col span={8}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.Services.ServicesForm.price")}
                  required={true}
                />
              }
              name="price"
              rules={[
                {
                  required: true,
                  message: t("Modules.Services.ServicesForm.pleaseEnterPrice"),
                },
                {
                  validator:(_, value) => {
                    if(value && value < 1) return Promise.reject(`${t("Modules.Services.ServicesForm.price")} ${t("CommonUtils.shouldBeGreaterThan0")}`);
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <Input
                type="number"
                placeholder={t("Modules.Services.ServicesForm.enterPrice")}
                onKeyDown={(e)=>allowCharactersOnlyForDecimalNumbers(e)}
              />
            </Form.Item>
          </Col>

            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default ElitePremium;
